export const SCHEDULE_DEMO_FORM_NAME = 'scheduleDemoForm';
export const TIME_INTERVAL = 15;
